module.exports = __webpack_public_path__ + "static/img/图文2.6fb3ea2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/图文2.jpg
// module id = u1CE
// module chunks = 1